import { fetchV1 } from "../lib/requester/v1";


/**
 * Get grant recommendations.
 *
 * @param {Object}   [payload]            - Request payload.
 * @param {string}   [payload.keyword]   - Optional keyword (sent only when present).
 * @returns {Promise<Response>}          - fetch response.
 */
export function grantRecommendations(payload = {}) {
	// Only include the `keyword` key when a non-empty string is supplied.
	const body = {};
  
	if (payload.keyword && typeof payload.keyword === "string" && payload.keyword.trim()) {
	  body.keyword = payload.keyword.trim();
	}
  
	// `fetchV1` is the wrapper you already use – it expects `{ method, data }`.
	return fetchV1(`/grants/recommendations`, {
	  method: "POST",
	  data: body,          // empty object → back-end will auto-generate keywords
	});
  }